<template>
  <section class="intro-container">
    <div class="intro-column">
      <div class="profile-pic">
        <img
          src="../assets/avatar.jpeg"
          alt="Pavel Shilov photo"
          style="pointer-events: none; user-select: none;"
        />
      </div>
    </div>
    <div class="intro-column">
      <div>
        <h1 class="intro-title color">Pavel Shilov</h1>
        <h2 class="intro-subtitle">Engineering Manager | Fintech <span style="padding-left: 5px;">🌐</span></h2>
      </div>
      <div class="intro-contacts">
        <div class="intro-link color">
          <img src="../assets/svg/language.svg" alt="languages" width="15" />
          <span>English</span> | <span>Czech</span> | <span>Russian</span>
        </div>
        <div class="intro-link color">
          <img src="../assets/svg/city.svg" alt="location" width="15" />
          <a href="https://maps.app.goo.gl/D2sE6La5DXdVLYH56" target="_blank"
            >Malaga | Spain</a
          >
        </div>
        <div class="intro-link color">
          <img src="../assets/svg/phone.svg" alt="call me" width="15" />
          <a href="tel:+34692922855">+34 692 922 855</a>
        </div>
        <div class="intro-link color">
          <img src="../assets/svg/email.svg" alt="email me" width="15" />
          <a href="mailto:pavel.shilov@protonmail.com"
            >pavel.shilov@protonmail.com</a
          >
        </div>
        <div class="intro-link color">
          <img src="../assets/svg/linkedin.svg" alt="linkedin" width="15" />
          <a href="https://www.linkedin.com/in/severus256/" target="_blank"
            >LinkedIn</a
          >
        </div>
        <div class="intro-link">
          <img src="../assets/svg/github.svg" alt="github" width="15" />
          <a href="https://github.com/shilovp" target="_blank">github</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ResumeIntro"
};
</script>

<style lang="scss">
.intro-container {
  display: flex;
  flex-flow: row wrap;
  padding: 10px;
  width: 100%;
}
.intro-column {
  width: 100%;
  max-width: 400px;

  display: flex;
  flex-direction: column;
  place-items: center;
}

.profile-pic {
  width: 210px;
  height: 210px;
  border: 5px solid #0f1b25;
  margin: 0 auto;
  overflow: hidden;
  text-align: center;
  border-radius: 100%;
  img {
    width: 188px;
    height: 188px;
    border-radius: 100%;
    -webkit-border-radius: 100%;
    margin-top: 6px;
  }
}

.intro-title {
  font-size: 40px;
  text-align: left;
  border-bottom: 1px solid #23415d;
  letter-spacing: -2pt;
  padding: 10px;
}

.intro-subtitle {
  font-size: 20px;
  font-weight: 200;
}

.intro-contacts {
  display: flex;
  flex-direction: column;
  width: 90%;
  padding-left: 6%;
  text-align: left;
}

.intro-contacts-column {
  padding: 15px;
}

.intro-link {
  display: flex;
  gap: 5px;
  flex-flow: row nowrap;
  a {
    text-decoration: none;
    font-weight: 600;
    color: #23415d;
  }
}

.color {
  color: #23415d;
}

.bold {
  font-weight: 700;
}
</style>